import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from "react";
import JsonLd from "../../modules/JsonLd"; // local

import SchemaParentOrganization from "./SchemaParentOrganization";
import SchemaSameAsOrganization from "./SchemaSameAsOrganization";

var SchemaOrganization = function SchemaOrganization(_ref) {
  var name = _ref.name,
      url = _ref.url,
      logo = _ref.logo,
      children = _ref.children,
      sameAs = _ref.sameAs,
      parentOrganization = _ref.parentOrganization;

  /**
   * if the component is inteded to be rendered as either, then return empty fragment
   * we return an empty fragment based on expected return type
   */
  if (sameAs || parentOrganization) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }

  var childJson = {};
  React.Children.forEach(children, function (child) {
    var type = child.type,
        props = child.props;
    var isSameAsChildNode = type === SchemaSameAsOrganization || props.sameAs;
    var isParentOrganizationChildNode = type === SchemaParentOrganization || props.parentOrganization;

    if (isSameAsChildNode) {
      childJson.sameAs = props.url;
    }

    if (isParentOrganizationChildNode) {
      childJson.parentOrganization = {
        "@context": "http://schema.org",
        "@type": "Organization",
        name: child.props.name,
        url: child.props.url
      };
    }
  });
  return /*#__PURE__*/React.createElement(JsonLd, {
    data: _objectSpread({
      "@context": "http://schema.org",
      "@type": "Organization",
      name: name,
      url: url,
      logo: logo
    }, childJson)
  });
};

SchemaOrganization.displayName = "SchemaOrganization";
SchemaOrganization.SameAs = SchemaSameAsOrganization;
SchemaOrganization.ParentOrganization = SchemaParentOrganization;
export default SchemaOrganization;